import { objToQs } from '../../Utils';

import Call from '../../Call.v2';

const Postback = {
    get(table, filters) {
        return Call(`pushapi/postback/report/${table}?${objToQs(filters)}`);
    },
    list(table, param, filters) {
        return Call(`pushapi/postback/report/${table}/${param}?${objToQs(filters)}`);
    },
};

export default Postback;



// WEBPACK FOOTER //
// ./src/services/API/components/PushapiPostback/index.js